import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { name: '首页', path: '/' },
    { name: '基础概念', path: '/category/sm-basics' },
    { name: '类型分类', path: '/category/sm-types' },
    { name: '安全准则', path: '/category/safety-guidelines' },
    { name: '实践指南', path: '/category/practice-guide' },
    { name: '心理与关系', path: '/category/psychology-relationships' },
    { name: '关于我们', path: '/about' },
  ];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
              SM
            </span>
            <span className="text-foreground-950 font-semibold text-base hidden sm:block">
              SM专业指南
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  isActive(link.path)
                    ? 'text-primary-500 bg-primary-100/70 font-medium'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 cursor-pointer"
            aria-label="菜单"
          >
            <i
              className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}
            ></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2.5 rounded-md text-sm transition-colors cursor-pointer ${
                  isActive(link.path)
                    ? 'text-primary-500 bg-primary-100/70 font-medium'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}